import Modal from './Modal';
import React, { FC, useState, useEffect } from 'react';
import classes from './BuyDialog.module.scss';
import { UserDTO } from '@envclient/envcore/src/types/core';
import Alert from './Alert';
import { ClosableCompProps } from './types';
import Button from './Button';
import { insertPayment } from '../service/paymentService';
import { getUserInfo } from '../service/userService';
import { RootState, useAppSelector } from '../reducers/store';
import { Product } from '../types/frontendTypes';

declare const CdvPurchase: any;

/**
 * InAppPurchase buy dialog.
 */

const productIds = ['credit_10', /*'credit_20',*/ 'credit_25', 'credit_50', 'credit_75', /*'credit_80',*/ 'credit_100'];

const BuyDialogApp: FC<ClosableCompProps> = ({ onClose, hidden }) => {
  const myUser = useAppSelector((state: RootState) => state.user) as UserDTO;
  const [selectedProduct, setSelectedProduct] = useState<Product>();
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [showErrorAlert, setShowErrorAlert] = useState<boolean>(false);

  const [products, setProducts] = useState<Product[]>([]);

  const { store, ProductType, Platform } = CdvPurchase;

  useEffect(() => {
    const initStore = async () => {
      console.log('Init store');
      try {
        // was hardcoded to GOOGLE_PLAY for every device - meant the store never registered/
        // initialized anything for Apple, so on iOS `products` stayed empty forever.
        const cdvPlatform = window.device.platform === 'Android' ? Platform.GOOGLE_PLAY : Platform.APPLE_APPSTORE;

        // Register product(s)
        await CdvPurchase.store.register(
          productIds.map((id) => ({
            id,
            type: CdvPurchase.ProductType.CONSUMABLE,
            platform: cdvPlatform
          }))
        );

        await CdvPurchase.store.ready();

        // Listen for product updates
        /*
        {
          "className": "Product",
          "title": "10 credits",
          "description": "10 credits",
          "platform": "android-playstore",
          "type": "consumable",
          "id": "credit_10",
          "offers": [
              {
                  "className": "Offer",
                  "id": "credit_10",
                  "pricingPhases": [
                      {
                          "price": "€1.19",
                          "priceMicros": 1190000,
                          "currency": "EUR",
                          "recurrenceMode": "NON_RECURRING"
                      }
                  ],
                  "productId": "credit_10",
                  "productType": "consumable",
                  "platform": "android-playstore",
                  "type": "inapp"
              }
          ]
      }
          */
        store.when().productUpdated((product: any) => {
          console.log('Product updated:', product);
          setProducts((prev) => {
            const others = prev.filter((p) => p.id !== product.id);
            return [...others, product];
          });
          if (product.id === 'credit_10') setSelectedProduct(product);
        });

        store.error(function (err) {
          console.error('Store error: ' + err.code + ' ' + err.message);
        });

        store.when().approved((transaction) => {
          console.log('Purchase approved:', transaction);
          /*

          {
              "className": "Transaction",
              "transactionId": "GPA.3318-6924-6234-87346",
              "state": "approved",
              "products": [
                  {
                      "id": "credit_25"
                  }
              ],
              "platform": "android-playstore",
              "nativePurchase": {
                  "orderId": "GPA.3318-6924-6234-87346",
                  "packageName": "air.com.ccson.Transylvania",
                  "productId": "credit_25",
                  "purchaseTime": 1759132037611,
                  "purchaseState": 0,
                  "purchaseToken": "glpfhhldjkcmkjhnchlchmen.AO-J1OzUY1zAWqPx7JlY2DVYrsGqzXKcvgEjzasIVDyFxz2-VR62q8eGDMGdlK0ZUmhbmD87V8ApXhzXmWAjvDQ2ktxcQ8jBwJg-JI-L5QwTpipl64E7dOc",
                  "quantity": 1,
                  "acknowledged": false,
                  "productIds": [
                      "credit_25"
                  ],
                  "getPurchaseState": 1,
                  "developerPayload": "",
                  "autoRenewing": false,
                  "accountId": "",
                  "profileId": "",
                  "signature": "BmlFMhNIi2XO7+FI9mgwKiyVIxsEOTFvU185jJ5wP21AQdydeQHlZmPIiBtmmEmzXMNpxTORNdn1v3dms/z4Z2I3LwVXzAr5bmsZ37qP6LIFjxQ+f7ka8weodxzuIs+HiPODSVu4obN6VC+xYMX6xGVj7UZ77+fGpYrFLjSDy4RXb0+HJGuThbtYAhBNEcmyTtoqKkXA9lnO2v6rIIh5OHxnv5p7kJJAzX5KUy/due0QDFyQB5k/RZBBjF8s9HJCmL1Iy4TqApJDB8EkpVFpIthj9XDpw7XoYtlPONJmaAj1RuhprPFGaVh8h7Gmg/JfenHB6N0P+xdCdHZ7OtN2uQ==",
                  "receipt": "{\"orderId\":\"GPA.3318-6924-6234-87346\",\"packageName\":\"air.com.ccson.Transylvania\",\"productId\":\"credit_25\",\"purchaseTime\":1759132037611,\"purchaseState\":0,\"purchaseToken\":\"glpfhhldjkcmkjhnchlchmen.AO-J1OzUY1zAWqPx7JlY2DVYrsGqzXKcvgEjzasIVDyFxz2-VR62q8eGDMGdlK0ZUmhbmD87V8ApXhzXmWAjvDQ2ktxcQ8jBwJg-JI-L5QwTpipl64E7dOc\",\"quantity\":1,\"acknowledged\":false}"
              },
              "purchaseId": "glpfhhldjkcmkjhnchlchmen.AO-J1OzUY1zAWqPx7JlY2DVYrsGqzXKcvgEjzasIVDyFxz2-VR62q8eGDMGdlK0ZUmhbmD87V8ApXhzXmWAjvDQ2ktxcQ8jBwJg-JI-L5QwTpipl64E7dOc",
              "purchaseDate": "2025-09-29T07:47:17.611Z",
              "isPending": false,
              "isAcknowledged": false,
              "renewalIntent": "Lapse"
          }
          */
          // Here you get order data
          console.log('Order ID:', transaction.transactionId);

          // Finish the transaction (acknowledge/consume)
          transaction.finish();

          // insertPayment + receipt validation. `nativePurchase` is a Google-Play-only field (see
          // GooglePlay.Transaction in cordova-plugin-purchase) - it does not exist on an Apple
          // transaction, so it must never be touched outside the Android branch (this used to be
          // referenced unconditionally above, which would have thrown on iOS before ever reaching
          // this if/else).
          let payload;
          if (window.device.platform === 'Android') {
            console.log('Purchase Token:', transaction.nativePurchase.purchaseToken);
            const credits = +String(transaction.nativePurchase.productId).split('_')[1];
            payload = {
              platform: 'Android',
              userId: myUser.userId,
              credits,
              itemId: transaction.nativePurchase.productId,
              paymentId: JSON.parse(transaction.nativePurchase.receipt).orderId,
              receipt: transaction.nativePurchase.receipt,
              signature: transaction.nativePurchase.signature
              //appVersion: settings.version
            };
          } else {
            // IOS - the base64 app receipt lives on the parent Receipt (SKApplicationReceipt),
            // not on the transaction itself: transaction.parentReceipt.nativeData.appStoreReceipt.
            // See cordova-plugin-purchase's appstore-receipt.ts / appstore-bridge.ts.
            const appStoreReceipt = transaction.parentReceipt?.nativeData?.appStoreReceipt;
            payload = {
              platform: 'IOS',
              userId: myUser.userId,
              credits: +transaction.products[0].id.split('_')[1],
              itemId: transaction.products[0].id,
              paymentId: transaction.transactionId,
              receipt: appStoreReceipt
              //appVersion: settings.version
            };
          }

          insertPayment(payload)
            .then((data) => {
              console.log('Insert payment success', data);
              handleBuyResult(true);
            })
            .catch((error) => {
              console.log('Insert payment error', error);
              handleBuyResult(false);
            });
        });

        CdvPurchase.store.initialize([cdvPlatform]);

        const product = CdvPurchase.store.get('credit_10');
        console.log('Product:', product);

        console.log('Store initialized ✅');
      } catch (err) {
        console.error('Store init failed', err);
      }
    };
    document.addEventListener('deviceready', initStore, false);

    return () => {
      document.removeEventListener('deviceready', initStore, false);
    };
  }, []);

  const handleBuy = async () => {
    if (!selectedProduct) return;
    const productId = selectedProduct?.id;

    try {
      const product = CdvPurchase.store.get(productId);
      if (!product) return alert('Product not found');

      const offer = product.offers?.[0];
      if (!offer) return alert('No offer found');

      await CdvPurchase.store.order(offer);
      console.log('Purchase success');
    } catch (err) {
      console.error('Purchase error', err);
      alert('Purchase failed');
    }
  };

  const handleClose = () => {
    getUserInfo().then(onClose);
  };

  const handleBuyResult = (success: boolean) => {
    if (success) setShowAlert(true);
    else setShowErrorAlert(true);
  };

  const handleChange = (productId: string) => {
    const p = products.find((p) => p.id === productId) as Product;
    setSelectedProduct(p);
  };

  if (hidden) return null;

  return (
    <>
      {showAlert && (
        <Alert
          title="Successful purchase"
          message="Thank you for buying credits! Your credits will appear shortly - please reload the page!"
          onClose={() => {
            setShowAlert(false);
            handleClose();
          }}
        />
      )}
      {showErrorAlert && (
        <Alert
          title="Purchase error"
          message="Purchase failed!"
          onClose={() => {
            setShowErrorAlert(false);
            handleClose();
          }}
        />
      )}

      <Modal>
        <div className={classes.mainCont}>
          <div className={classes.bg}></div>
          <div className={classes.panel}>
            <div className={classes.header}>
              <div className={classes.title}>Buy credits</div>
            </div>
            <div className={classes.body}>
              <p className={classes.text}>Please select the amount of credits you wish to buy and click Continue.</p>
              <div className={classes.optionRow}>
                <label htmlFor="amount">Amount</label>
                {selectedProduct ? (
                  <select
                    name="amount"
                    id="amount"
                    value={selectedProduct.id}
                    onChange={(e) => handleChange(e.target.value)}>
                    {products.map((p) => {
                      return (
                        <option key={p.id} value={p.id}>
                          {`${p.description} - ${p.offers?.[0]?.pricingPhases?.[0]?.price}`}
                        </option>
                      );
                    })}
                  </select>
                ) : (
                  <span>{'Loading items - please wait...'}</span>
                )}
              </div>
              <div className={classes.optionRow}></div>
            </div>
            <div className={classes.btnBar}>
              <Button onClick={handleClose}>Cancel</Button>
              <Button onClick={handleBuy} disabled={!selectedProduct}>
                Continue
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default BuyDialogApp;
